import React from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import * as Actions from '../../actions';
import { Authenticate } from '../../queries';

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userName: localStorage['login_user_name'] || '',
            password: localStorage['login_pin_code'] || '',
            graphQlBaseUrl: localStorage['graphql_base_url'] || '',
            pos24ApiBaseUrl: localStorage['pos24_api_base_url'] || '',
            message: '',
            debugInfo: ''
        };
    }

    render() {
        const tokenUrl = ((this.state.graphQlBaseUrl || '').trim().replace(/\/+$/, '')) + '/Token';

        return (
            <div style={{ padding: '20px' }}>
                <div>
                    Oturum bilgileri gereklidir!
                </div>

                <TextField
                    hintText='Kullanıcı'
                    floatingLabelText='Kullanıcı'
                    value={this.state.userName}
                    onChange={this.onUserNameChange}
                />

                <TextField
                    hintText='Parola alanı'
                    floatingLabelText='Parola'
                    type='password'
                    value={this.state.password}
                    onChange={this.onPasswordChange}
                />

                <br />

                <TextField
                    hintText='Örn: https://garsonapi-.bulunet.xyz'
                    floatingLabelText='GraphQL Base Url'
                    value={this.state.graphQlBaseUrl}
                    onChange={this.onGraphQlBaseUrlChange}
                    fullWidth={true}
                />

                <TextField
                    hintText='Örn: https://api.pos24net.com'
                    floatingLabelText='POS24 API Base Url'
                    value={this.state.pos24ApiBaseUrl}
                    onChange={this.onPos24ApiBaseUrlChange}
                    fullWidth={true}
                />

                <br />
                <br />

                <div>{this.state.message}</div>

                <br />

                <RaisedButton label='OK' onClick={this.onClick} />
                <br />

                <RaisedButton
                    label='Konfigurasyon Ayarları'
                    onClick={this.openConfigSettings}
                    disabled={!this.state.graphQlBaseUrl || this.state.graphQlBaseUrl.trim() === ''}
                />
                <br />
                <RaisedButton
                    label='Sipariş Ayarları'
                    onClick={this.openTicketSettings}
                    disabled={!this.state.graphQlBaseUrl || this.state.graphQlBaseUrl.trim() === ''}
                />
                <br />
                <RaisedButton
                    label='Sipariş Hareketleri'
                    onClick={this.openOrderSettings}
                    disabled={!this.state.graphQlBaseUrl || this.state.graphQlBaseUrl.trim() === ''}
                />

                <br />
                <br />

                <div style={{
                    padding: '10px',
                    marginTop: '10px',
                    border: '1px solid #ccc',
                    background: '#fff8dc',
                    fontSize: '12px',
                    lineHeight: '1.5',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word'
                }}>
                    <b>DEBUG</b>
                    {'\n'}Page URL: {window.location.href}
                    {'\n'}Location Protocol: {window.location.protocol}
                    {'\n'}Location Host: {window.location.host}
                    {'\n'}GraphQL Base URL: {this.state.graphQlBaseUrl}
                    {'\n'}Token URL: {tokenUrl}
                    {'\n'}Debug Info: {this.state.debugInfo}
                    {'\n'}Message: {this.state.message}
                    {'\n'}POS24 API URL: {this.state.pos24ApiBaseUrl}
                </div>
            </div>
        );
    }

    openConfigSettings = () => {
        var baseUrl = (this.state.graphQlBaseUrl || '').trim().replace(/\/+$/, '');
        var pos24ApiUrl = (this.state.pos24ApiBaseUrl || '').trim().replace(/\/+$/, '');

        if (baseUrl) {
            localStorage['graphql_base_url'] = baseUrl;
        }

        localStorage['pos24_api_base_url'] = pos24ApiUrl || '';

        this.context.router.push('/config-settings');
    }

    openTicketSettings = () => {
        var baseUrl = (this.state.graphQlBaseUrl || '').trim().replace(/\/+$/, '');
        var pos24ApiUrl = (this.state.pos24ApiBaseUrl || '').trim().replace(/\/+$/, '');

        if (baseUrl) {
            localStorage['graphql_base_url'] = baseUrl;
        }

        localStorage['pos24_api_base_url'] = pos24ApiUrl || '';

        this.context.router.push('/ticket-settings');
    }

    openOrderSettings = () => {
        var baseUrl = (this.state.graphQlBaseUrl || '').trim().replace(/\/+$/, '');
        var pos24ApiUrl = (this.state.pos24ApiBaseUrl || '').trim().replace(/\/+$/, '');

        if (baseUrl) {
            localStorage['graphql_base_url'] = baseUrl;
        }

        localStorage['pos24_api_base_url'] = pos24ApiUrl || '';

        this.context.router.push('/order-settings');
    }

    onUserNameChange = (e) => {
        this.setState({ userName: e.target.value });
    }

    onPasswordChange = (e) => {
        this.setState({ password: e.target.value });
    }

    onGraphQlBaseUrlChange = (e) => {
        this.setState({ graphQlBaseUrl: e.target.value });
    }

    appendDebug = (text) => {
        this.setState(prev => ({
            debugInfo: (prev.debugInfo || '') + '\n' + text
        }));
    }

    onPos24ApiBaseUrlChange = (e) => {
        this.setState({ pos24ApiBaseUrl: e.target.value });
    }

    onClick = () => {
        try {
            var baseUrl = (this.state.graphQlBaseUrl || '').trim().replace(/\/+$/, '');
            var pos24ApiUrl = (this.state.pos24ApiBaseUrl || '').trim().replace(/\/+$/, '');
            var userName = (this.state.userName || '').trim();

            if (!baseUrl || !userName) {
                this.setState({
                    message: 'Bağlantı adresi ve kullanıcı adı zorunludur.',
                    debugInfo: 'Eksik bağlantı adresi veya kullanıcı adı.'
                });
                return;
            }

            var tokenUrl = baseUrl + '/Token';

            this.appendDebug('Login başladı');
            this.appendDebug('Base URL => ' + baseUrl);
            this.appendDebug('Token URL => ' + tokenUrl);

            localStorage['graphql_base_url'] = baseUrl;
            localStorage['pos24_api_base_url'] = pos24ApiUrl;
            localStorage['login_user_name'] = userName;
            localStorage['login_pin_code'] = this.state.password || '';

            Authenticate(
                userName,
                this.state.password,

                (accessToken, refreshToken) => {
                    this.appendDebug('Auth başarılı');

                    localStorage['access_token'] = accessToken;
                    localStorage['refresh_token'] = refreshToken;

                    this.props.authenticationSuccess(accessToken, refreshToken);
                    this.context.router.push('/');
                },

                (errorCode, errorMessage) => {
                    this.appendDebug('Auth hata');
                    this.appendDebug('Code: ' + errorCode);
                    this.appendDebug('Message: ' + errorMessage);

                    if (errorCode === 0) {
                        this.appendDebug('Muhtemel neden: CORS / Mixed Content / Network');
                    }

                    this.setState({
                        password: '',
                        message: errorMessage
                    });
                }
            );
        }
        catch (ex) {
            this.appendDebug('TRY/CATCH ERROR => ' + ex.message);
            console.error(ex);
        }
    }
}

Login.contextTypes = {
    router: React.PropTypes.object
};

const mapStateToProps = state => ({
    isAuthenticating: state.login.get('isAuthenticating'),
    accessToken: state.login.get('accessToken'),
    refreshToken: state.login.get('refreshToken')
});

const mapDispatchToProps = ({
    authenticationSuccess: Actions.authenticationSuccess,
    authenticationFailure: Actions.authenticationFailure
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./app/components/Login/Login.jsx